import {Component, OnInit} from '@angular/core';
import {CustomAlertService} from './custom-alert.service';

@Component({
    selector: 'custom-alert',
    standalone: false,
    templateUrl: 'custom-alert.component.html',
    styleUrls: ['./custom-alert.component.scss']
})

export class CustomAlertComponent implements OnInit {
    mensajes = [];
    tiempo = 3500;
    constructor(private customAlertService: CustomAlertService) {
    }

    ngOnInit() {
        this.customAlertService.getCustomService().subscribe(mensaje => {
            this.mensajes.push(mensaje.mensaje);
            this.tiempo = mensaje.tiempo;
            this.removerNotifications();
        });
    }

    private removerNotifications() {
        const that = this;
        setTimeout(function () {
            that.mensajes.splice(0, 1);
            if (that.mensajes.length > 0) {
                that.removerNotifications();
            }
        }, this.tiempo);
    }
}
